import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { BUTTON_CAPTION } from 'constants/common';

// Components
import {
  Text,
  Button,
} from '@beef/ui-kit';
import { Icon } from 'components';

// Styles
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const BackButton = React.memo(({ onClick }) => (
  <Button
    onClick={onClick}
    icon={<Icon name="arrow" className={cx('icon')} />}
    variant="plain"
  >
    <Text size="size6-r" color="grey50">
      {BUTTON_CAPTION.BACK}
    </Text>
  </Button>
));

BackButton.propTypes = {
  onClick: PropTypes.func,
};
